import { InjectionKey } from 'vue';
import { useDashboardFiltersProvider } from './dashboard-filter.provider';

export const IKDashboardFilters = Symbol('IKDashboardFilters') as InjectionKey<ReturnType<typeof useDashboardFiltersProvider>>;
